import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { BrowserService } from './browser.service';
import { ErrorService } from './error.service';

@Injectable({ providedIn: 'root' })
export class PostLoginNavigationService {
    constructor(
        private readonly browserService: BrowserService,
        private readonly router: Router,
        private readonly errorService: ErrorService
    ) {}

    navigateAfterLogin(returnUrl?: string): void {
        if (returnUrl) {
            const url = this.browserService.parseUrl(returnUrl);

            if (url != null && url.hostname !== environment.crsIntegration.domain) {
                globalThis.location.href = url.origin;
                return;
            }

            const params: any = { redirect_uri: returnUrl };
            this.router.navigate(['saleschannelselector'], { queryParams: params })
                .catch(() => this.errorService.onConsoleError('Error navigating to saleschannelselector with query params'));
            return;
        }

        this.router.navigate(['saleschannelselector'])
            .catch(() => this.errorService.onConsoleError('Error navigating to saleschannelselector'));
    }
}